export const fontFamily: string = 'Roboto';

// Helper to get max stack value for y-axis
export function getMaxStack(data: BarChartData): number {
  return data.labels.reduce((max, _label, idx) => {
    const stackSum = data.datasets.reduce(
      (sum, ds) => sum + (ds.data[idx] || 0),
      0,
    );
    return Math.max(max, stackSum);
  }, 0);
}

export function getBarChartColor(color: ChartColor): string {
  const style = window.getComputedStyle(document.body);
  return style.getPropertyValue(
    chartMapColor.get(color) ?? chartMapColor.get('primary')!,
  );
}

// Centralized Chart.js config for stacked bar charts
export function getBarChartConfig(
  data: BarChartData,
  fontFamily: string,
  maxStack: number,
  xAxeDisplay?: boolean,
  yAxeDisplay?: boolean,
): any {
  return {
    type: 'bar',
    data: data,
    options: {
      responsive: true,
      maintainAspectRatio: false,
      interaction: {
        mode: 'index',
        intersect: false,
      },
      plugins: {
        // datalabels: {
        //   display: true,
        //   anchor: 'end',
        //   align: 'end',
        //   color: '#000',
        //   font: {
        //     weight: 'bold',
        //     family: fontFamily,
        //   },
        // },
        legend: {
          display: true,
          position: 'bottom',
        },
        title: {
          display: false,
        },
        tooltip: {
          enabled: true,
          callbacks: {
            label: function (context) {
              let label = context.dataset.label || '';

              if (label) {
                label += ': ';
              }
              if (context.parsed.y !== null) {
                label +=
                  Number.parseFloat(context.parsed.y).toLocaleString('fr-FR', {
                    minimumFractionDigits: 0,
                    maximumFractionDigits: 0,
                  }) + ' €';
              }
              return label;
            },
          },
          //   enabled: true,
          //   mode: 'index',
          //   intersect: false,
          //   filter: tooltipFilter,
          //   callbacks: {
          //     label: tooltipLabel,
          //   },
        },
      },
      scales: {
        x: {
          display: xAxeDisplay,
          stacked: false,
        },
        y: {
          display: yAxeDisplay,
          beginAtZero: true,
          stacked: false,
          //set max value + 2 to avoid cutting off sum label
          suggestedMax: Math.ceil(maxStack + maxStack * 0.1),
          ticks: {
            // Include a dollar sign in the ticks
            callback: function (value, index, ticks) {
              return (
                Number.parseFloat(value).toLocaleString('fr-FR', {
                  minimumFractionDigits: 0,
                  maximumFractionDigits: 0,
                }) + ' €'
              );
            },
          },
        },
      },
      font: {
        family: fontFamily,
      },
    },
  };
}

export type ChartColor =
  | 'blue'
  | 'green'
  | 'orange'
  | 'red'
  | 'grey'
  | 'primary'
  | 'attendanceSchedule'
  | 'attendancePing';

export const chartMapColor = new Map<ChartColor, string>([
  ['blue', '--charts-color-blue'],
  ['green', '--charts-color-green'],
  ['orange', '--charts-color-orange'],
  ['red', '--charts-color-red'],
  ['grey', '--charts-color-grey'],
  ['primary', '--charts-color-primary'],
  ['attendanceSchedule', '--charts-color-attendance-schedule'],
  ['attendancePing', '--charts-color-attendance-ping'],
]);

export type BarChartData = {
  labels: string[];
  datasets: Dataset[];
};

export type Dataset = {
  label: string;
  data: number[];
  backgroundColor: string;
  barPercentage?: number; // space between bars in a category
};
